export const events = [
  {
    id: "summer-camp-2026",
    title: "Summer Camp 2026",
    date: "May 10 - June 05, 2026",
    desc: "A fun-filled summer camp with workshops in music, sports, art & craft, cooking without fire, and introductory STEAM experiments.",
    status: "Upcoming",
    coverImage: "img10", // will match to relevant image
    ctaText: "Register Now"
  },
  {
    id: "parent-orientation-2026",
    title: "Parent Orientation Session",
    date: "June 25, 2026",
    desc: "An interactive session welcoming new parents, explaining curriculum goals, daily routines, and school policies.",
    status: "Upcoming",
    coverImage: "img11",
    ctaText: "Book Slot"
  },
  {
    id: "annual-sports-2026",
    title: "Annual Sports Day 2026",
    date: "January 15, 2026",
    desc: "A vibrant day of track races, balancing challenges, and athletic relays celebrating our young champions' active spirits.",
    status: "Completed",
    coverImage: "img3",
    ctaText: "View Photos"
  },
  {
    id: "grandparents-day-2025",
    title: "Grandparents Day Celebration",
    date: "September 12, 2025",
    desc: "Special day filled with games, music performances, and activities honoring the presence of grandparents in early childhood.",
    status: "Completed",
    coverImage: "img9",
    ctaText: "View Photos"
  }
];
